export default {
  dear: {
    DealerName: 'Dealer Name',
    Region: 'Region',
    Province: 'Province',
    City: 'City',
    Status: 'Status',
    ComeFrom: 'ComeFrom',
    No: 'No',
    Code: 'Code',
    DealerType: 'Dealer Type',
    Mobile: 'Mobile',
    PriceLevel: 'Price Level',
    Salesman: 'Salesman',
    CreateTime: 'Create Time',
    ModifyTime: 'Modify Time',
    Operation: 'Operation',

    Linkman: 'Linkman',
    Telephone: 'Telephone',
    Birthday: 'Birthday',
    Area: 'Area',
    ZipCode: 'ZipCode',
    Address: 'Address',
    Remark: 'Remark',
    AccountName: 'AccountName',
    AccountBank: 'AccountBank',
    BankAccountNo: 'BankAccountNo',
    InitDue: 'InitDue',
    Due: 'Due',
    InitBalance: 'InitBalance',
    CreditLine: 'CreditLine',
    CautionMoney: 'CautionMoney',
    AnnualMission: 'AnnualMission',
    LoginName: 'LoginName',
    Password: 'Password',
    OrderDiscount: 'OrderDiscount',
    Edit: 'Edit',
    ChooseDealer: 'Choose Dealer'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/dealer.js